import { useState } from 'react'
import { Alert, Group, Loader, Select, Stack } from '@mantine/core'
import { IconAlertCircle } from '@tabler/icons-react'
import { useDevices } from '../api/devices'
import MapContainer from '../components/map'
import { DeviceDetails } from '../components/DeviceDetails'
import { DatePickerInput } from '@mantine/dates'

function defaultRange(): [Date, Date] {
  const today = new Date()
  const thirtyDaysAgo = new Date(today)
  thirtyDaysAgo.setDate(today.getDate() - 30)
  return [thirtyDaysAgo, today]
}

export default function LandingPage() {
  const {
    data: devices,
    isPending: devicesPending,
    isError: devicesError,
    error,
  } = useDevices()

  const [[start, end], setDateRange] =
    useState<[Date | null, Date | null]>(defaultRange())
  const [selectedDevice, setSelectedDevice] = useState<string | null>(null)
  console.log(start, end)

  if (devicesPending) {
    return (
      <Stack align="center" justify="center" maw="100%">
        <Loader />
      </Stack>
    )
  }

  if (devicesError) {
    return (
      <Stack align="center" justify="center" maw="100%" w="100%">
        <Alert icon={<IconAlertCircle size="1rem" />} title="Error" color="red">
          {error.message}
        </Alert>
      </Stack>
    )
  }

  return (
    <Stack>
      <div
        style={{
          boxShadow: 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px',
          padding: '10px 75px',
        }}
      >
        <Group>
          <Select
            data={devices.map((device) => ({
              value: device.imei,
              label: `${device.imei} (${device.name})`,
            }))}
            value={selectedDevice}
            onChange={setSelectedDevice}
            label="Select device"
            placeholder="Select device"
            searchable
            clearable
            maw={250}
            miw={150}
            w="full"
          />
          {selectedDevice != null && (
            <DatePickerInput
              type="range"
              label="Period"
              placeholder="Pick dates range"
              value={[start, end]}
              onChange={setDateRange}
            />
          )}
        </Group>
      </div>
      {!selectedDevice && <MapContainer devices={devices} />}
      {selectedDevice && start && end && (
        <DeviceDetails deviceImei={selectedDevice} start={start} end={end} />
      )}
    </Stack>
  )
}
